define((require) => {
    "use strict";

    const _     = require("underscore");
    const Scene = require("shared/ui/experience/Scene");

    /**
     * Model for the overlay scene.
     *
     * @class OverlayScene
     * @constructor
     */
    return Scene.extend({
        defaults: _.defaults({
            sceneNumber: "overlay"
        }, Scene.prototype.defaults)
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/OverlayScene.js